// 12 · Notificaciones — agrupadas por día; no leídas con fondo cálido y
// marca lateral naranja. Chips Todas / Señales / Resultados / Cuenta.
// "Leídas" en el .nav marca todo. Tap abre el detalle del partido.
// Fuente: señales emitidas (signals_history), alertas RADAR
// (radar_vip_results), resumen diario (helpers Performance Lab) y cuenta.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Nav, EmptyFull, SigSkeleton, I, OffBar } from '../ui';
import { useNotificaciones, relTime, dayGroup, useOnline } from '../hooks';

const ICON = {
  g: <I.signal />, w: <I.clock />, n: <I.x />, d: <I.send width={16} height={16} />, '': <I.cal />,
};
const iconFor = (n) => {
  if (n.kind === 'resultado') return n.icon === 'g' ? <I.check width={16} height={16} strokeWidth="2.6" /> : <I.x />;
  return ICON[n.icon] || ICON[''];
};

export default function Notificaciones() {
  const navigate = useNavigate();
  const { items, loading, markAllRead, markRead } = useNotificaciones();
  const { online, sinceStr } = useOnline();
  const [f, setF] = useState('todas');

  const lista = items.filter((n) => f === 'todas'
    || (f === 'senales' && n.kind === 'señal')
    || (f === 'resultados' && n.kind === 'resultado')
    || (f === 'cuenta' && n.kind === 'cuenta'));

  const grupos = [];
  for (const n of lista) {
    const g = dayGroup(n.ts);
    const last = grupos[grupos.length - 1];
    if (last && last.g === g) last.items.push(n); else grupos.push({ g, items: [n] });
  }

  const abrir = (n) => {
    markRead(n.id);
    if (n.gid) navigate(`/app/partido/${n.gid}`);
    else if (n.kind === 'cuenta') navigate('/app/cuenta');
  };

  return (
    <div className="v3"><div className="scroll nt safe-top" style={grupos.length === 0 && !loading ? { display: 'flex', flexDirection: 'column' } : undefined}>
      <Nav title="Notificaciones" onBack={() => navigate('/app')}
        action={<button type="button" className="act" style={{ width: 38, textAlign: 'right', fontSize: 12 }} onClick={markAllRead}>Leídas</button>} />
      {!online && <OffBar since={sinceStr} />}
      <div className="chips" style={{ paddingTop: 4 }}>
        {[['todas', 'Todas'], ['senales', 'Señales'], ['resultados', 'Resultados'], ['cuenta', 'Cuenta']].map(([k, l]) => (
          <button key={k} type="button" className={`v3chip${f === k ? ' on' : ''}`} onClick={() => setF(k)}>{l}</button>
        ))}
      </div>

      {loading && <><SigSkeleton /><SigSkeleton /></>}

      {!loading && grupos.length === 0 && (
        <EmptyFull icon={<I.bell width={26} height={26} />} title="Todo al día">
          No tienes notificaciones nuevas. Cada señal que emita el motor llegará aquí y como push.
        </EmptyFull>
      )}

      {grupos.map(({ g, items: its }, gi) => (
        <div key={g}>
          <p className="grp" style={{ paddingTop: gi === 0 ? 2 : 14 }}>{g}</p>
          {its.map((n) => (
            <button type="button" key={n.id} className={`nf${n.unread ? ' unread' : ''}`} onClick={() => abrir(n)}>
              <div className={`ic ${n.icon || ''}`}>{iconFor(n)}</div>
              <div className="b">
                <p className="k">{n.k}<span className="tm">{relTime(n.ts)}</span></p>
                <p className="tt">{n.tt}</p>
                <p className="dd" dangerouslySetInnerHTML={{ __html: n.dd }} />
              </div>
            </button>
          ))}
        </div>
      ))}
    </div></div>
  );
}
